import useResource from "./useResource"

export default function useFindComparableTopicRecordsView({ deal, topic }) {
  const key = `deals/${deal.id}/comparables/topics/${topic.id}/available_records/view`
  return useResource({ key })
}
